/** Simple comparer that takes 2 simple types and compares them.
 * Can be used for  {@link Array.prototype.sort} etc.
 * @parameters has to be of the same type
 * @returns If a is less than b returns -1
 * @returns If a is bigger than b returns 1
 * @returns If they're the same returns 0 */
export function sortComparer<T>(a: T, b: T, ascending: boolean = false): -1 | 0 | 1 {
  return a < b ? (ascending ? -1 : 1) : a > b ? (ascending ? 1 : -1) : 0;
}
